



















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class UHeader extends Vue {
  public header = this.$refs.header;

  private isHamMenu = false;

  private mounted() {
    if (this.$route.name === "Top") {
      this.getElement();
    }
  }

  private getElement() {
    this.header = this.$refs.header;
  }

  public setClass() {
    (this.header as Element).classList.toggle("header-sticky");
  }
}
